var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Cấu hình cảnh báo giới hạn học sinh",
        width: "620px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _c("div", { staticClass: "ps-dialog-intro" }, [
        _c("div", { staticClass: "ps-dialog-intro__icon" }, [
          _c("i", { staticClass: "el-icon-setting" }),
        ]),
        _c("div", [
          _c("h3", [_vm._v("Thiết lập ngưỡng dùng chung")]),
          _c("p", [
            _vm._v(
              "Giá trị được lưu trong hệ thống và áp dụng cho tất cả trường khi chạy API test hoặc batch cảnh báo."
            ),
          ]),
        ]),
      ]),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "configForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "ps-alert-config-grid" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Ngưỡng sử dụng (%)",
                    prop: "thresholdPercent",
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "ps-full-width",
                    attrs: {
                      min: 0,
                      max: 100,
                      step: 1,
                      precision: 1,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.thresholdPercent,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "thresholdPercent", $$v)
                      },
                      expression: "form.thresholdPercent",
                    },
                  }),
                  _c("span", { staticClass: "ps-form-hint" }, [
                    _vm._v(
                      "Cảnh báo khi đạt từ tỷ lệ này so với giới hạn gói."
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Số lượng còn lại tối đa",
                    prop: "remainingSlots",
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "ps-full-width",
                    attrs: {
                      min: 0,
                      max: 2147483647,
                      step: 1,
                      precision: 0,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.remainingSlots,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remainingSlots", $$v)
                      },
                      expression: "form.remainingSlots",
                    },
                  }),
                  _c("span", { staticClass: "ps-form-hint" }, [
                    _vm._v(
                      "Cảnh báo khi số lượng còn lại không vượt quá giá trị này."
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Gửi lại sau (ngày)",
                    prop: "notificationIntervalDays",
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "ps-full-width",
                    attrs: {
                      min: 0,
                      max: 2147483647,
                      step: 1,
                      precision: 0,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.notificationIntervalDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "notificationIntervalDays", $$v)
                      },
                      expression: "form.notificationIntervalDays",
                    },
                  }),
                  _c("span", { staticClass: "ps-form-hint" }, [
                    _vm._v("Nhập 0 nếu không giới hạn khoảng cách gửi lại."),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "Tiêu đề thông báo", prop: "notificationTitle" },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "255",
                  "show-word-limit": "",
                  placeholder: "Nhập tiêu đề thông báo",
                },
                model: {
                  value: _vm.form.notificationTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "notificationTitle", $$v)
                  },
                  expression: "form.notificationTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "Nội dung thông báo",
                prop: "notificationContent",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "1000",
                  "show-word-limit": "",
                  placeholder: "Nhập nội dung thông báo",
                },
                model: {
                  value: _vm.form.notificationContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "notificationContent", $$v)
                  },
                  expression: "form.notificationContent",
                },
              }),
              _c("span", { staticClass: "ps-form-hint" }, [
                _vm._v(
                  "\n        Biến hỗ trợ: {ten_truong}, {so_hoc_sinh_hien_tai}, {gioi_han_hoc_sinh}, {so_cho_con_lai},\n        {so_hoc_sinh_vuot}, {ty_le_su_dung}, {trang_thai}.\n        Biến {trang_thai} tự đổi theo trường đang còn trong giới hạn hoặc đã vượt giới hạn.\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.config && _vm.config.updatedAt
        ? _c("p", { staticClass: "ps-form-hint" }, [
            _vm._v(
              "\n    Cập nhật gần nhất: " +
                _vm._s(_vm._f("formatDate")(_vm.config.updatedAt)) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Hủy")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.submit },
            },
            [_vm._v("Lưu cấu hình")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }